export default {
  init() {
    // JavaScript to be fired on the q and a page
    // add active class to form on trigger
    $(function () {
      $('.q-a-item').click(function () {
        $(this).toggleClass('opened');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the q and a page, after the init JS
  },
};



//////////////////
// WEBPACK FOOTER
// ./scripts/routes/q-and-a.js
// module id = 20
// module chunks = 0